import { get } from '@classic/Foundation/Services/ApiService'

export const getPendingTicketsCount = () =>
  get<{ pendingTicketsCount?: number }>({
    url: '/$_/accountActivity/tickets/pending/count',
  })
